module.exports = __webpack_public_path__ + "img/Picture6.3e1a4e6a.png";